import type { ReactNode } from 'react';
import { Checkbox as AntdCheckbox } from 'antd';
import type { CheckboxGroupProps as AntCheckboxGroupProps } from 'antd/es/checkbox';
import { useFela } from 'react-fela';

import * as felaRules from './CheckboxGroup.rules';

export interface CheckboxGroupProps extends AntCheckboxGroupProps {
    children: ReactNode;
    customStyle?: typeof felaRules.container;
}

export function CheckboxGroup({ customStyle, ...props }: CheckboxGroupProps) {
    const { css } = useFela();
    return <AntdCheckbox.Group {...props} className={css(felaRules.container, customStyle)} />;
}
